export class UpdateServicioRequest {
    
    public id : number=0;
    public id_TipoServicio :  number=0;
    public broche: boolean= false;
    public nroBroche: string = ""
    
}